export const subjectOptions = [
   { value: "2021/2022-3", label: "Mathematics" },
   { value: "2021/2022-2", label: "Biology" },
   { value: "2021/2022-1", label: "Physics" },
];
export const classOptions = [
   { value: "2021/2022-3", label: "JSS 1" },
   { value: "2021/2022-2", label: "JSS 2" },
   { value: "2021/2022-1", label: "JSS 3" },
];
export const studentOptions = [
   { id: 1, firstname: 'John', surname: 'Doe' },
   { id: 2, firstname: 'Jane', surname: 'Smith' },
   { id: 3, firstname: 'Michael', surname: 'Johnson' },
   { id: 4, firstname: 'Emily', surname: 'Davis' },
   { id: 5, firstname: 'Chris', surname: 'Brown' },
   { id: 6, firstname: 'Sarah', surname: 'Wilson' },
   { id: 7, firstname: 'David', surname: 'Garcia' },
   { id: 8, firstname: 'Jessica', surname: 'Martinez' },
   { id: 9, firstname: 'Daniel', surname: 'Lopez' },
   { id: 10, firstname: 'Samantha', surname: 'Gonzalez' },
   { id: 11, firstname: 'Matthew', surname: 'Perez' },
   { id: 12, firstname: 'Ashley', surname: 'Taylor' },
   { id: 13, firstname: 'Joshua', surname: 'Anderson' },
   { id: 14, firstname: 'Hannah', surname: 'Thomas' },
   { id: 15, firstname: 'Andrew', surname: 'Moore' },
   { id: 16, firstname: 'Megan', surname: 'Jackson' },
   { id: 17, firstname: 'Ryan', surname: 'Martin' },
   { id: 18, firstname: 'Olivia', surname: 'Lee' },
   { id: 19, firstname: 'Brandon', surname: 'White' },
   { id: 20, firstname: 'Alyssa', surname: 'Harris' },
   { id: 21, firstname: 'Ethan', surname: 'Clark' },
   { id: 22, firstname: 'Sophia', surname: 'Lewis' },
   { id: 23, firstname: 'Tyler', surname: 'Robinson' },
   { id: 24, firstname: 'Mia', surname: 'Walker' },
   { id: 25, firstname: 'Jack', surname: 'Young' },
   { id: 26, firstname: 'Lily', surname: 'King' },
   { id: 27, firstname: 'Logan', surname: 'Wright' },
   { id: 28, firstname: 'Grace', surname: 'Scott' },
   { id: 29, firstname: 'Alexander', surname: 'Green' },
   { id: 30, firstname: 'Isabella', surname: 'Baker' },
   { id: 31, firstname: 'Mason', surname: 'Hall' },
   { id: 32, firstname: 'Ella', surname: 'Adams' },
   { id: 33, firstname: 'Aiden', surname: 'Nelson' },
   { id: 34, firstname: 'Zoe', surname: 'Hill' },
   { id: 35, firstname: 'Lucas', surname: 'Ramirez' },
   { id: 36, firstname: 'Ava', surname: 'Campbell' },
   { id: 37, firstname: 'Liam', surname: 'Mitchell' },
   { id: 38, firstname: 'Chloe', surname: 'Carter' },
   { id: 39, firstname: 'James', surname: 'Roberts' },
   { id: 40, firstname: 'Natalie', surname: 'Phillips' }
];